exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".web-components-___DealMetrics__metrics___2azci{display:flex;flex-wrap:wrap;margin-bottom:0}.web-components-___DealMetrics__metrics___2azci>div{width:50%;color:#95989a;margin-bottom:.8em}.web-components-___DealMetrics__metrics___2azci>div>dd{margin-left:0;font-weight:700}", ""]);

// exports
exports.locals = {
	"metrics": "web-components-___DealMetrics__metrics___2azci"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]&?minimize=true!./web/components/DealMetrics.css
// module id = 1327
// module chunks = 0